import React from 'react';
import {
  SvgIcon
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';




export default function HomeIconCarre(props: SvgIconProps) {
  return (
    <SvgIcon {...props} className="icon-svg" sx={{ fontSize: '2.375rem', height: 'auto' }}>

        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21" fill="none">
          <path d="M19.5718 9.80078C19.8216 9.94517 19.8217 10.3059 19.5718 10.4502L6.72803 17.8652C6.4781 18.0095 6.16571 17.8295 6.16553 17.541L6.16553 2.70996C6.16553 2.42128 6.47803 2.24043 6.72803 2.38477L19.5718 9.80078Z" fill="#22588A" stroke="white" stroke-width="0.75"/>
          <path d="M28.0815 9.80078C28.3314 9.94517 28.3315 10.3059 28.0815 10.4502L15.2378 17.8652C14.9879 18.0095 14.6755 17.8295 14.6753 17.541L14.6753 2.70996C14.6753 2.42128 14.9878 2.24043 15.2378 2.38477L28.0815 9.80078Z" fill="#22588A" stroke="white" stroke-width="0.75"/>
        </svg>

    </SvgIcon>
  );
}
